<template>
    <PreLoginView>
        <PreLoginForm :logo="type == 'success'">
            <lottie-animation
                :path="animation"
                style="width: 60%; margin-bottom: 1rem"
            />
            <transition mode="out-in" name="fade">
                <div class="signup-form">
                    <div class="pre-login-title">{{ $t(header) }}</div>
                    <div class="pre-login-subtitle">{{ $t(body) }}</div>
                    <PreLoginButton
                        :label="buttonLabel"
                        @click="confirmStatus"
                        class="login-form-button"
                        style="margin-top: 2rem"
                    />
                </div>
            </transition>
        </PreLoginForm>
        <transition name="fade" mode="out-in">
            <AppLoading v-if="initLoading" />
        </transition>
    </PreLoginView>
</template>
<script>
import AppLoading from '@/components/tools/AppLoading'
import PreLoginView from '@/views/PreLoginView/PreLoginView'
export default {
    components: {
        PreLoginForm: () => import('@/views/PreLoginView/PreLoginForm'),
        PreLoginButton: () => import('@/views/PreLoginView/PreLoginButton'),
        PreLoginView,
        AppLoading
    },
    data() {
        return {
            textVisible: false,
            type: '',
            body: '',
            initLoading: true,
            fallback: ''
        }
    },
    computed: {
        animation() {
            return this.type == 'success'
                ? 'lottie/rocket.json'
                : 'lottie/error.json'
        },
        buttonLabel() {
            return this.statusType == 'confirm_account_success' && this.jwt
                ? this.$t('BUTTON_LOGIN')
                : this.$t('BUTTON_OK')
        },
        region() {
            return this.$route.query.region
        },
        jwt() {
            return this.$route.query.jwt
        },
        statusType() {
            return this.$route.params.type
        },
        header() {
            return this.type == 'success'
                ? this.$t('LABEL_SUCCESS')
                : this.$t('TOAST_ERROR_TITLE')
        }
    },
    methods: {
        setMessage() {
            switch (this.statusType) {
                case 'reset_password_success':
                    this.type = 'success'
                    this.fallback = 'mobile_login'
                    this.body = this.$t('EMAIL_TEXT_CHANGED_PASSWORD')
                    break
                case 'reset_password_failure':
                    this.type = 'error'
                    this.fallback = 'mobile_login'
                    this.body = this.$t('LABEL_RESET_SUCCESS')
                    break
                case 'confirm_account_success':
                    this.type = 'success'
                    this.body = this.$t('LABEL_ACTIVATE_SUCCESS')
                    this.handleUser()
                    break
                case 'confirm_account_failure':
                    this.type = 'error'
                    this.body = this.$t('LABEL_ACTIVATE_ERRROR')
                    break
                case 'signup_success':
                    this.type = 'success'
                    this.body = this.$t(
                        'TOAST_MESSAGE_SIGNUP_SUCCESS_MAIL_LEFT'
                    )
                    break
                case 'unknown_error':
                    this.type = 'error'
                    this.body = this.$t(
                        'TOAST_MESSAGE_SIGNUP_SUCCESS_MAIL_LEFT'
                    )
                    break
                case 'apply_successful':
                    this.type = 'success'
                    this.body = this.$t('PARENT_APPLY_SUCCESS_MESSAGE')
                    break
                case 'catering_request_successful':
                    this.type = 'success'
                    this.fallback = 'return'
                    this.body = this.$t('CATERING_ORDER_REQUEST_SUCCESS')
                    break
            }
        },
        confirmStatus() {
            switch (this.fallback) {
                case 'return':
                    return this.$router.go(-1)
                case 'mobile_login':
                    return this.goToMobileLogin()
                default:
                    return (window.location = this.$env.getMainApp())
            }
        },
        goToMobileLogin() {
            if (this.$Utils.isMobileDevice()) {
                window.location = `livekid://login`
                setTimeout(() => {
                    window.location = this.$env.getMainApp()
                }, 3000)
            } else {
                window.location = this.$env.getMainApp()
            }
        },
        setLoading() {
            if (this.statusType != 'confirm_account_success' || !this.jwt) {
                this.initLoading = false
            }
            setTimeout(() => {
                this.textVisible = true
            }, 3000)
        },
        handleUser() {
            this.$Utils.isMobileDevice()
                ? this.handleMobileDevice()
                : this.goToMainApp()
        },
        goToMainApp() {
            if (!this.jwt) return
            this.$store.dispatch('resetStore')
            window.location.href = `${this.$env.getMainApp()}?jwt=${
                this.jwt
            }&region=${this.region}`
        },
        handleMobileDevice() {
            if (this.statusType == 'confirm_account_success' && this.jwt) {
                window.location.href = `livekid://login?jwt=${this.jwt}&region=${this.region}`
            } else {
                window.location.href = `livekid://`
            }
            setTimeout(() => {
                switch (this.$Utils.mobileDeviceType()) {
                    case 'android':
                        window.location =
                            'https://play.google.com/store/apps/details?id=com.livekidmobileadmin'
                        break
                    case 'ios':
                        window.location =
                            'market://details?id=com.livekidmobileadmin&hl=pl'
                        break
                }
            }, 1500)
            setTimeout(() => {
                this.initLoading = false
            }, 3000)
        }
    },
    mounted() {
        this.setMessage()
        this.setLoading()
    }
}
</script>

<style lang="scss" scoped>
.signup-form {
    display: flex;
    flex-direction: column;
    width: 100%;
    z-index: 100;
    min-width: 250px;
}
.login-view {
    &::after {
        @media (max-width: 1000px) {
            opacity: 0;
        }
    }
}
</style>
